import { AsyncPaginate } from 'react-select-async-paginate';
import { RestS } from '../../../rest/rest-service';
import { useCallback, useRef, useState } from 'react';
import { ActionMeta, components } from 'react-select';
import styles from './AsyncSelectField.module.scss'
import { useForm } from 'react-final-form';
import { CircularProgress } from '@mui/material';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import { HiSearch as SearchIcon } from 'react-icons/hi';


const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderRadius: "0.5rem",
        // margin: 8,
        border: "1px solid #d4d4d4",
        outline: 0,
        // padding: "0.15rem 0.3rem",
        height: "40px",
        boxShadow: "none",
        "fontFamily": "Work Sans",
        "fontSize": "0.875rem",
        "fontStyle": "normal",
        "fontWeight": "500",
        "lineHeight": "1.125rem", /* 128.571% */
        "letterSpacing": "0.00875rem",
        backgroundColor: "#F9F9F9",

        "@media only screen and (max-width: 576px)": {
            "fontFamily": "Work Sans",
            "fontSize": "0.6875rem",
            "fontStyle": "normal",
            "fontWeight": "500",
            "lineHeight": "0.875rem", /* 128.571% */
            "letterSpacing": "0.00688rem",
            "height": "2rem"
        },

        ":hover": {
            cursor: "pointer",
            border: "1px solid #d4d4d4"
        }
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: "#fff",
        borderRadius: "0.5rem",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            color: "#212121",
            backgroundColor: isFocused ? "#F0EFF4" : "transparent",
            "fontFamily": "Work Sans",
            "fontSize": "0.875rem",
            "fontStyle": "normal",
            "fontWeight": "500",
            "lineHeight": "1.125rem", /* 128.571% */
            "letterSpacing": "0.00875rem",
            "padding": "0",
            // padding: "0.75rem",

            ':active': {
                backgroundColor: "#F0EFF4",
            }
        }
    },
    placeholder: (styles) => ({
        ...styles,
        color: "#aaaaaa",
        "fontFamily": "Work Sans",
        "fontSize": "0.875rem",
        "fontStyle": "normal",
        "fontWeight": "400",
        "lineHeight": "1.125rem", /* 128.571% */
        "letterSpacing": "0.00875rem",

        "@media only screen and (max-width: 576px)": {
            "fontFamily": "Work Sans",
            "fontSize": "0.6875rem",
            "fontStyle": "normal",
            "fontWeight": "400",
            "lineHeight": "0.875rem", /* 128.571% */
            "letterSpacing": "0.00688rem",
        },
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    group: (styles) => ({
        padding: "0rem"
    }),
    menuList: (base) => ({
        ...base,
        "::-webkit-scrollbar": {
            width: "5px",
            height: "0px",
        },
    }),
    noOptionsMessage: (styles) => {
        return {
            ...styles,
            color: "#56595C",
            "fontFamily": "Work Sans",
            "fontSize": "0.875rem",
            "fontStyle": "normal",
            "fontWeight": "500",
            "lineHeight": "1.125rem", /* 128.571% */
            "letterSpacing": "0.00875rem",
        }
    },
    groupHeading: (styles) => ({
        ...styles,
        "fontFamily": "Work Sans",
        "fontSize": "0.875rem",
        "fontStyle": "normal",
        "fontWeight": "700",
        "lineHeight": "1.125rem", /* 128.571% */
        "letterSpacing": "0.00875rem",
        color: "#56595C",
        padding: "0.75rem",
        margin: "0rem"
    })
}

const CustomControl = ({ children, ...props }) => {
    return (
        <components.Control {...props as any}>
            <span className={styles.searchIcon}>
                <SearchIcon />
            </span>
            {children}

        </components.Control>
    )
}

const CustomSelectOption = ({ ipConfig, ...props }) => {

    return (
        <components.Option  {...props as any} >
            <div className={`${styles.customOption}`}>
                <div className={styles.checkboxField}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => { }} // Prevents checkbox from triggering on its own
                    // style={{ marginRight: 8 }}
                    />

                </div>
                <div className={styles.ipContainer}>
                    {ipConfig[props.data.integrationPartner] ? <img src={ipConfig[props.data.integrationPartner]['logo']} alt="" /> : null}
                </div>
                <label style={{ width: '100%', cursor: 'pointer' }}>
                    <div className={styles.productContainer}>
                        <div className={styles.productTitle}>
                            {props.label}
                        </div>
                        <div className={styles.skuVarContainer}>
                            {props?.data?.sku ? <div className={styles.productDetailsText}>
                                {props?.data?.sku}
                            </div> : null}
                            {props?.data?.sku && props?.data?.variant ? <div className={styles.productDetailsSeparator}></div> : null}
                            <div className={styles.productDetailsText}>
                                {props?.data?.variant}
                            </div>
                        </div>
                    </div>
                </label>
            </div>
        </components.Option>
    )
}

type Props = {
    ipConfig: { [x: string]: any },
    value: any,
    onChange: (selectedOption: any, actionType: any) => void;
}

const AsyncSelectField = ({ ipConfig, onChange, value }: Props) => {
    const [inputValue, setInputValue] = useState('');
    const { mutators } = useForm();
    const selectRef = useRef(null);
    const [menuIsOpen, setMenuIsOpen] = useState(false);



    const loadOptions = useCallback(async (search, loadedOptions, { page }) => {
        try {
            console.log('page triggering', page);
            const response: any = await RestS.getProductsData(null, search, page);
            console.log('response', response)
            return {
                options: response?.data,
                hasMore: response?.paginationData?.nextPageNumber != null,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            console.log('error', error);
        }
    }, [])

    const handleInputChange = (newInputValue) => {
        setInputValue(newInputValue);
        return newInputValue;
    };




    return (
        <>
            <AsyncPaginate
                selectRef={selectRef}
                inputValue={inputValue}
                value={value ?? []}
                loadOptions={loadOptions}
                getOptionValue={(option: any) => option.productId}
                getOptionLabel={(option: any) => option.productName}
                menuPortalTarget={document.body}
                additional={{
                    page: 0,
                }}
                components={{
                    Option: (props) => <CustomSelectOption ipConfig={ipConfig}   {...props} />,
                    LoadingMessage: (props) => {
                        return <components.LoadingMessage {...props}>

                            <div className={styles.loadingContainer}>
                                <CircularLoader />
                            </div>
                        </components.LoadingMessage>
                    },
                    Control: CustomControl,
                    DropdownIndicator: (props) => <></>
                }}
                placeholder={"Type Product's Name"}
                styles={customStyles}
                onChange={(values, actionMeta) => {
                    onChange(actionMeta.option, actionMeta?.action);
                    // setTimeout(() => {
                    //     selectRef?.current?.focus();
                    // }, 100);
                }}
                isMulti
                isClearable={false}

                onInputChange={(value, action) => {
                    if (action.action == "input-change") {
                        handleInputChange(value)
                    } else if (action.action == "menu-close") {
                        handleInputChange(value)
                    }
                }}
                blurInputOnSelect={false}
                controlShouldRenderValue={false}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}

            />
        </>
    );
}

export default AsyncSelectField;